import Enum from 'enum'

export default new Enum({
  'UNKNOWN': 0,
  'STAGING': 1,
  'US_1': 2,
  'STAGING_2': 3,
  'US_2': 4,
  'EU_1': 5,
})